<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog key="advanced" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="lock-to-top">
	<div class="main-top-group">
		<!--  	   	 	 -->
		<!-- TOP SECTION -->
		<!-- 			 -->
		<div class="column-group">
			<div class="column1">
				<!--  	   	   -->
				<!-- Group Name -->
				<!-- 		   -->
				<!-- <div class="column-item">
					<div>
						<label class="column-item-label">Group Name</label>
					</div>
	
					<div style="margin-left: 10px">
						<label style="color: blue;">{{GroupName}}</label>
					</div>				
				</div> -->

				<div class="column-item">
					<div>
						<label class="column-item-label">Prompt Type</label>
					</div>

					<div style="margin-left: 10px; width: 300px">
						<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
						<select class="form-control" name="SelectedPromptTypeIDSelector" style="font-size: smaller" [(ngModel)]="SelectedPromptTypeID">
							<option *ngFor="let r of lstPromptType" [ngValue]="r.ID">
								{{ r.Desc }}
							</option>
						</select>
					</div>
				</div>

				<!-- 		    -->
				<!-- IncidentDT -->
				<!-- 		    -->
				<div class="column-item">
					<div>
						<label class="column-item-label">Date / Time</label>
					</div>

					<div style="margin-left: 10px">
						<p-calendar
							[style]="{ width: '100%' }"
							[inputStyle]="{ width: '100%' }"
							[(ngModel)]="rIncidentDT"
							[showTime]="true"
							hourFormat="12"
							showIcon="true"
							inputId="incidentdt"
						></p-calendar>
					</div>
				</div>

				<!-- 	 		      -->
				<!-- FacilityLocation -->
				<!-- 		    	  -->
				<div class="column-item">
					<div>
						<label class="column-item-label">Facility Location</label>
					</div>

					<div style="margin-left: 10px; width: 300px">
						<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
						<select
							class="form-control"
							name="SelectedFacilityLocationSelector"
							style="font-size: smaller"
							[(ngModel)]="SelectedFacilityLocation"
							(ngModelChange)="onFacilityLocationChange($event)"
						>
							<option *ngFor="let r of lstFacilityLocationItems" [ngValue]="r">
								{{ r.FacilityLocationName }}
							</option>
						</select>
					</div>
				</div>

				<!--  	   	    -->
				<!-- Alert Info -->
				<!-- 		    -->
				<div class="column-item">
					<div class="column-item-alert">
						<!--  	   	        -->
						<!-- Continue Alert -->
						<!-- 		     	-->
						<div>
							<label class="column-item-label">Alert</label>
						</div>

						<div style="margin-left: 10px">
							<p-checkbox [(ngModel)]="rContinueAlert" [binary]="true"></p-checkbox>
						</div>
					</div>
				</div>

				<!--  	   	   -->
				<!-- Susp Info -->
				<!-- 		   -->
				<div style="margin-top: 25px" [style.display]="rHasSusp == true ? 'block' : 'none'">
					<div style="background-color: #dadada">
						<!-- 	     				 -->
						<!-- Date Range / School Day -->
						<!-- 	     				 -->
						<div class="column-item">
							<div>
								<label class="column-item-label">Range/Day</label>
							</div>

							<div style="margin-left: 10px">
								<p-radioButton
									name="radio3"
									value="1"
									label="By Date Range"
									[(ngModel)]="selectedRadioValue"
									(onClick)="onRadioChange()"
								></p-radioButton>
							</div>

							<div style="margin-left: 10px">
								<p-radioButton
									name="radio3"
									value="2"
									label="By School Days"
									[(ngModel)]="selectedRadioValue"
									(onClick)="onRadioChange()"
								></p-radioButton>
							</div>
						</div>
					</div>

					<!--  	   	                        -->
					<!-- Radio 1 - Date Range Selection -->
					<!-- 		             			-->
					<div [style.display]="selectedRadioValue == '1' ? 'block' : 'none'">
						<!--  	   -->
						<!-- #Days -->
						<!-- 	   -->
						<div class="column-item">
							<div>
								<label class="column-item-label">Suspension Days</label>
							</div>

							<div style="margin-left: 10px">
								<label style="color: blue; width: 35px">{{ rSuspNbrDays1 }}</label>
							</div>

							<div style="margin-left: 25px">
								<label>Min Days</label>
							</div>

							<div style="margin-left: 10px">
								<label style="color: blue">{{ rMinDurationDayCount }}</label>
							</div>

							<div style="margin-left: 15px">
								<label>Max Days</label>
							</div>

							<div style="margin-left: 10px">
								<label style="color: blue">{{ rMaxDurationDayCount }}</label>
							</div>
						</div>

						<!-- 		    -->
						<!-- Start Date -->
						<!-- 		    -->
						<div class="column-item">
							<div>
								<label class="column-item-label">Start Date</label>
							</div>

							<div style="margin-left: 10px">
								<p-calendar
									[style]="{ width: '100%' }"
									[inputStyle]="{ width: '100%' }"
									[(ngModel)]="rStartDate1"
									(ngModelChange)="onStartDate1Change($event)"
									[showTime]="false"
									hourFormat="12"
									showIcon="true"
									inputId="StartDate1"
								></p-calendar>
							</div>
						</div>

						<!-- 	      -->
						<!-- End Date -->
						<!-- 	      -->
						<div class="column-item">
							<div>
								<label class="column-item-label">End Date</label>
							</div>

							<div style="margin-left: 10px">
								<p-calendar
									[style]="{ width: '100%' }"
									[inputStyle]="{ width: '100%' }"
									[(ngModel)]="rEndDate1"
									(ngModelChange)="onEndDate1Change($event)"
									[showTime]="false"
									hourFormat="12"
									showIcon="true"
									inputId="EndDate1"
								></p-calendar>
							</div>
						</div>
					</div>

					<!--  	   	                       -->
					<!-- Radio 2 -School Day Selection -->
					<!-- 		             		   -->
					<div [style.display]="selectedRadioValue == '2' ? 'block' : 'none'">
						<!--  	   -->
						<!-- #Days -->
						<!-- 	   -->
						<div class="column-item">
							<div>
								<label class="column-item-label">Suspension Days</label>
							</div>

							<div style="margin-left: 10px">
								<input
									type="text"
									pInputText
									[(ngModel)]="rSuspNbrDays2"
									(ngModelChange)="onSuspNbrDays2()"
									maxlength="4"
									style="width: 35px"
								/>
							</div>

							<div style="margin-left: 25px">
								<label>Min Days</label>
							</div>

							<div style="margin-left: 10px">
								<label style="color: blue">{{ rMinDurationDayCount }}</label>
							</div>

							<div style="margin-left: 15px">
								<label>Max Days</label>
							</div>

							<div style="margin-left: 10px">
								<label style="color: blue">{{ rMaxDurationDayCount }}</label>
							</div>
						</div>

						<!-- 		    -->
						<!-- Start Date -->
						<!-- 		    -->
						<div class="column-item">
							<div>
								<label class="column-item-label">Start Date</label>
							</div>

							<div style="margin-left: 10px">
								<p-calendar
									[style]="{ width: '100%' }"
									[inputStyle]="{ width: '100%' }"
									[(ngModel)]="rStartDate2"
									(ngModelChange)="onStartDate2Change($event)"
									[showTime]="false"
									hourFormat="12"
									showIcon="true"
									inputId="StartDate2"
								></p-calendar>
							</div>
						</div>

						<!-- 	      -->
						<!-- End Date -->
						<!-- 	      -->
						<div class="column-item">
							<div>
								<label class="column-item-label">End Date</label>
							</div>

							<div style="margin-left: 10px">
								<p-calendar
									[style]="{ width: '100%' }"
									[inputStyle]="{ width: '100%' }"
									[(ngModel)]="rEndDate2"
									[disabled]="true"
									(ngModelChange)="onEndDate2Change($event)"
									[showTime]="false"
									hourFormat="12"
									showIcon="true"
									inputId="EndDate2"
								></p-calendar>
							</div>
						</div>
					</div>
				</div>

				<!--  	   	              -->
				<!-- Portal Notifications -->
				<!-- 		              -->
				<div class="column-item">
					<div>
						<label class="column-item-label">Send Notifications:</label>
					</div>

					<div
						style="
							margin-left: 10px;
							display: grid;
							align-items: center;
							grid-template-columns: auto auto auto auto auto auto;
							grid-column-gap: 5px;
						"
					>
						<p-checkbox inputId="ParentPortalSendNotification" [(ngModel)]="ParentPortalSendNotification" [binary]="true"></p-checkbox>
						<label class="NoMargin" for="ParentPortalSendNotification">Parent Portal</label>

						<p-checkbox
							style="margin-left: 15px"
							inputId="StudentPortalSendNotification"
							[(ngModel)]="StudentPortalSendNotification"
							[binary]="true"
						></p-checkbox>
						<label class="NoMargin" for="StudentPortalSendNotification">Student Portal</label>

						<p-checkbox
							inputId="StaffPortalSendNotification"
							style="margin-left: 15px"
							[(ngModel)]="StaffPortalSendNotification"
							[binary]="true"
						></p-checkbox>
						<label class="NoMargin" for="StaffPortalSendNotification">Staff Portal</label>
					</div>
				</div>
			</div>

			<!--  	   	  -->
			<!-- Comments -->
			<!-- 		  -->
			<div class="column2">
				<div class="column-item">
					<div>
						<button class="btn btn-primary btn-sm" style="margin-left: 0px" (click)="onAddComment()">Add</button>
						<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onEditComment()">Edit</button>
						<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onRemoveComment()">Remove</button>
					</div>

					<div style="margin-left: 25px">
						<label>Discipline Last Edited by</label>
					</div>

					<div style="margin-left: 5px">
						<label style="color: #d19a02">{{ rAdminName }}</label>
					</div>
				</div>

				<!-- 				  -->
				<!-- Display Comments -->
				<!-- 				  -->
				<div class="table-main-comment">
					<!-- Note: resizableColumns breaks the multiline ability -->
					<p-table
						#dtComments
						[value]="lstCommentItems"
						[paginator]="true"
						[(rows)]="C_pagerows"
						[(first)]="C_pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						[(loading)]="isBusy"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedComment"
						dataKey="IncidentImageID"
						(onSort)="onHandleSort_C($event)"
						(onRowSelect)="onRowSelect_C($event)"
						(onRowUnselect)="onRowUnselect_C($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[1, 2, 3, 5]"
					>
						<ng-template pTemplate="header">
							<!-- 			  -->
							<!-- Sort Section -->
							<!-- 			  -->
							<tr>
								<th pSortableColumn="c_date" class="fixwidth-14">Date / Time<p-sortIcon field="c_date"></p-sortIcon></th>
								<th pSortableColumn="IncidentImageTitle">Title<p-sortIcon field="IncidentImageTitle"></p-sortIcon></th>
								<th pSortableColumn="IncidentImageComment">Comment<p-sortIcon field="IncidentImageComment"></p-sortIcon></th>
								<th pSortableColumn="StaffName" class="fixwidth-14">Staff<p-sortIcon field="StaffName"></p-sortIcon></th>
							</tr>
						</ng-template>

						<ng-template pTemplate="body" let-rCommentItem>
							<tr [pSelectableRow]="rCommentItem" (dblclick)="onRowDblClick(rCommentItem)">
								<td>
									<div class="fixwidth-14">
										{{ rCommentItem.c_date | date : "MMM d, y, h:mm a" }}
									</div>
								</td>

								<td>
									<div>
										{{ rCommentItem.IncidentImageTitle }}
									</div>
								</td>

								<td>
									<div>
										{{ rCommentItem.IncidentImageComment }}
									</div>
								</td>

								<td>
									<div class="fixwidth-14">
										{{ rCommentItem.StaffName }}
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!--------------------------------------------------------------------------------------------------------->
<!--------------------------------------------------------------------------------------------------------->
<!-- ASSIGNED SECTION -->
<!--------------------------------------------------------------------------------------------------------->
<!--------------------------------------------------------------------------------------------------------->

<!-- 		 		  	  -->
<!-- ASSIGNED INFRACTIONS -->
<!-- 		 		      -->
<div class="main-ptable-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned-i">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRemoveInfraction()">Remove</button>
			<img class="info-img" (click)="onToggleInfractionAInfo()" src="assets/images/info-24.png" />
			<label class="button-body-all-text" style="margin-left: 25px">Assigned Infractions</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfractionAInfo == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned Infractions: {{ lstAssignedInfractionItems.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display Assigned     -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssignedInfractions
				[value]="lstAssignedInfractionItems"
				[paginator]="true"
				[(rows)]="AI_pagerows"
				[(first)]="AI_pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedAssignedInfraction"
				dataKey="InfractionID"
				(onSort)="onHandleSort_AI($event)"
				(onRowSelect)="onRowSelect_AI($event)"
				(onRowUnselect)="onRowUnselect_AI($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[3, 5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="isPrimary" class="fixwidth-08">Primary<p-sortIcon field="isPrimary"></p-sortIcon></th>
						<th pSortableColumn="InfractionCD">Code<p-sortIcon field="InfractionCD"></p-sortIcon></th>
						<th pSortableColumn="InfractionDesc">Description<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
						<th pSortableColumn="InfractionLevelDesc">Level<p-sortIcon field="InfractionLevelDesc"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rInfractionItem>
					<tr [pSelectableRow]="rInfractionItem">
						<td class="fixwidth-08">
							<div>
								<p-checkbox
									[(ngModel)]="rInfractionItem.isPrimary"
									[binary]="true"
									(onChange)="onChangePrimaryInfraction(rInfractionItem)"
								></p-checkbox>
							</div>
						</td>

						<td>
							<div class="table-data-desc">
								{{ rInfractionItem.InfractionCD }}
							</div>
						</td>

						<td>
							<div class="table-data-desc">
								{{ rInfractionItem.InfractionDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-desc">
								{{ rInfractionItem.InfractionLevelDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rInfractionItem.SchoolID <= 0,
									'table-color-def-4': rInfractionItem.SchoolID > 0
								}"
							>
								{{ rInfractionItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rInfractionItem.DefinedByID == 1,
									'table-color-def-2': rInfractionItem.DefinedByID == 2,
									'table-color-def-3': rInfractionItem.DefinedByID == 3,
									'table-color-def-4': rInfractionItem.DefinedByID == 4
								}"
							>
								{{ rInfractionItem.DefinedByDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  	  -->
		<!-- Display When No Infractions  -->
		<!-- 						  	  -->
		<div style="padding: 20px" [style.display]="lstAssignedInfractionItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No infractions assigned...</label>
		</div>
	</div>
</div>

<!-- 		 		  -->
<!-- ASSIGNED ACTIONS -->
<!-- 		 		  -->
<div class="main-ptable-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned-a-group">
			<div class="button-body-assigned-a">
				<button class="btn btn-primary" style="margin-left: 0px" (click)="onRemoveAction()">Remove</button>
				<img class="info-img" (click)="onToggleActionAInfo()" src="assets/images/info-24.png" />
				<label class="button-body-all-text" style="margin-left: 25px">Assigned Actions</label>
			</div>

			<div class="button-body-assigned-a">
				<button
					class="btn btn-primary"
					style="margin-left: 0px"
					(click)="onPlayAssigned()"
					[disabled]="isBusy == true || SelectedAssignedPenalty == null || SelectedAssignedPenalty.SoundData.length == 0"
				>
					Play
				</button>
				<button
					class="btn btn-primary"
					style="margin-left: 5px"
					(click)="onStopAssigned()"
					[disabled]="isBusy == true || SelectedAssignedPenalty == null || SelectedAssignedPenalty.SoundData.length == 0"
				>
					Stop
				</button>
			</div>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowActionAInfo == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned Actions: {{ lstAssignedPenaltyItems.length }}</label
			><br />
			<label>&#9900; When Description is bold*, then this action is type suspension.</label><br />
			<label>&#9900; You can only have one action of type suspension assigned.</label><br />
			<label>&#9900; Action of type suspension must be set as Primary.</label><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display Assigned     -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssignedActions
				[value]="lstAssignedPenaltyItems"
				[paginator]="true"
				[(rows)]="AA_pagerows"
				[(first)]="AA_pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedAssignedPenalty"
				dataKey="PenaltyID"
				(onSort)="onHandleSort_AA($event)"
				(onRowSelect)="onRowSelect_AA($event)"
				(onRowUnselect)="onRowUnselect_AA($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[3, 5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="isPrimary" class="fixwidth-08">Primary<p-sortIcon field="isPrimary"></p-sortIcon></th>
						<th pSortableColumn="PenaltyCD">Code<p-sortIcon field="PenaltyCD"></p-sortIcon></th>
						<th pSortableColumn="PenaltyDesc">Description<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
						<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rPenaltyItem>
					<tr [pSelectableRow]="rPenaltyItem">
						<td class="fixwidth-08">
							<div>
								<p-checkbox [(ngModel)]="rPenaltyItem.isPrimary" [binary]="true" (onChange)="onChangePrimaryAction(rPenaltyItem)"></p-checkbox>
							</div>
						</td>

						<td>
							<div class="table-data-desc">
								{{ rPenaltyItem.PenaltyCD }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc"
								[ngClass]="{
									'sel-pen': rPenaltyItem.isSusp == false,
									'sel-pen-susp': rPenaltyItem.isSusp == true
								}"
							>
								{{ rPenaltyItem.PenaltyDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-desc" style="font-weight: bold" [ngStyle]="{ color: rPenaltyItem.FontColor }">
								{{ rPenaltyItem.Message }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.SchoolID <= 0,
									'table-color-def-4': rPenaltyItem.SchoolID > 0
								}"
							>
								{{ rPenaltyItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.DefinedByID == 1,
									'table-color-def-2': rPenaltyItem.DefinedByID == 2,
									'table-color-def-3': rPenaltyItem.DefinedByID == 3,
									'table-color-def-4': rPenaltyItem.DefinedByID == 4
								}"
							>
								{{ rPenaltyItem.DefinedByDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstAssignedPenaltyItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No actions assigned...</label>
		</div>
	</div>
</div>

<!--------------------------------------------------------------------------------------------------------->
<!--------------------------------------------------------------------------------------------------------->
<!-- SELECT UNASSIGNED SECTION -->
<!--------------------------------------------------------------------------------------------------------->
<!--------------------------------------------------------------------------------------------------------->

<!-- 		 	 -->
<!-- INFRACTIONS -->
<!-- 		 	 -->
<div class="main-ptable-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-unassigned-i">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onAssignInfraction()">Assign</button>
			<img class="info-img" (click)="onToggleInfractionUInfo()" src="assets/images/info-24.png" />
			<label class="button-body-all-text" style="margin-left: 25px">Assignable Infractions</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #b5dabb" [style.display]="isShowInfractionUInfo == true ? 'block' : 'none'">
			<label>&#9900; Total Infractions: {{ lstInfractionItems.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 				 	 -->
		<!-- Display Infractions -->
		<!-- 				 	 -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtUnassignedInfractions
				[value]="lstInfractionItems"
				[paginator]="true"
				[(rows)]="UI_pagerows"
				[(first)]="UI_pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedInfraction"
				dataKey="InfractionID"
				(onSort)="onHandleSort_UI($event)"
				(onRowSelect)="onRowSelectUI($event)"
				(onRowUnselect)="onRowUnselectUI($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 				-->
					<!-- Filter Section -->
					<!-- 				-->
					<tr>
						<th>
							<p-columnFilter type="text" field="InfractionCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="InfractionDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="InfractionLevelDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="SchoolsDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterInfractionSchoolsDesc
										[ngModel]="value"
										[options]="lstInfractionSchoolsDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterInfractionDefinedByDesc
										[ngModel]="value"
										[options]="lstInfractionDefinedByDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="InfractionCD">Code<p-sortIcon field="InfractionCD"></p-sortIcon></th>
						<th pSortableColumn="InfractionDesc">Description<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
						<th pSortableColumn="InfractionLevelDesc">Level<p-sortIcon field="InfractionLevelDesc"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rInfractionItem>
					<tr [pSelectableRow]="rInfractionItem">
						<td>
							<div class="table-data-desc">
								{{ rInfractionItem.InfractionCD }}
							</div>
						</td>

						<td>
							<div class="table-data-desc">
								{{ rInfractionItem.InfractionDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-desc">
								{{ rInfractionItem.InfractionLevelDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rInfractionItem.SchoolID <= 0,
									'table-color-def-4': rInfractionItem.SchoolID > 0
								}"
							>
								{{ rInfractionItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rInfractionItem.DefinedByID == 1,
									'table-color-def-2': rInfractionItem.DefinedByID == 2,
									'table-color-def-3': rInfractionItem.DefinedByID == 3,
									'table-color-def-4': rInfractionItem.DefinedByID == 4
								}"
							>
								{{ rInfractionItem.DefinedByDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  	  -->
		<!-- Display When No Infractions  -->
		<!-- 						  	  -->
		<div style="padding: 20px" [style.display]="lstInfractionItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No infractions configured...</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- ACTIONS -->
<!-- 		 -->
<div class="main-ptable-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-unassigned-a-group">
			<div class="button-body-unassigned-a">
				<button class="btn btn-primary" style="margin-left: 0px" (click)="onAssignAction()">Assign</button>
				<img class="info-img" (click)="onToggleActionUInfo()" src="assets/images/info-24.png" />
				<label class="button-body-all-text" style="margin-left: 25px">Assignable Actions</label>
			</div>

			<div class="button-body-unassigned-a">
				<button
					class="btn btn-primary"
					style="margin-left: 0px"
					(click)="onPlayAssignable()"
					[disabled]="isBusy == true || SelectedPenalty == null || SelectedPenalty.SoundData.length == 0"
				>
					Play
				</button>
				<button
					class="btn btn-primary"
					style="margin-left: 5px"
					(click)="onStopAssignable()"
					[disabled]="isBusy == true || SelectedPenalty == null || SelectedPenalty.SoundData.length == 0"
				>
					Stop
				</button>
			</div>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #b5dabb" [style.display]="isShowActionUInfo == true ? 'block' : 'none'">
			<label>&#9900; Total Actions: {{ lstPenaltyItems.length }}</label
			><br />
			<label>&#9900; When Description is bold*, then this action is type suspension.</label><br />
			<label>&#9900; You can only have one action of type suspension assigned.</label><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 				 -->
		<!-- Display Actions -->
		<!-- 				 -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtUnassignedActions
				[value]="lstPenaltyItems"
				[paginator]="true"
				[(rows)]="UA_pagerows"
				[(first)]="UA_pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedPenalty"
				dataKey="PenaltyID"
				(onSort)="onHandleSort_UA($event)"
				(onRowSelect)="onRowSelectUA($event)"
				(onRowUnselect)="onRowUnselectUA($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 				-->
					<!-- Filter Section -->
					<!-- 				-->
					<tr>
						<th>
							<p-columnFilter type="text" field="PenaltyCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="PenaltyDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="SchoolsDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterActionSchoolsDesc
										[ngModel]="value"
										[options]="lstActionSchoolsDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterActionDefinedByDesc
										[ngModel]="value"
										[options]="lstActionDefinedByDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="PenaltyCD">Code<p-sortIcon field="PenaltyCD"></p-sortIcon></th>
						<th pSortableColumn="PenaltyDesc">Description<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
						<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rPenaltyItem>
					<tr [pSelectableRow]="rPenaltyItem">
						<td>
							<div class="table-data-desc">
								{{ rPenaltyItem.PenaltyCD }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc"
								[ngClass]="{
									'sel-pen': rPenaltyItem.isSusp == false,
									'sel-pen-susp': rPenaltyItem.isSusp == true
								}"
							>
								{{ rPenaltyItem.PenaltyDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-desc" style="font-weight: bold" [ngStyle]="{ color: rPenaltyItem.FontColor }">
								{{ rPenaltyItem.Message }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.SchoolID <= 0,
									'table-color-def-4': rPenaltyItem.SchoolID > 0
								}"
							>
								{{ rPenaltyItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.DefinedByID == 1,
									'table-color-def-2': rPenaltyItem.DefinedByID == 2,
									'table-color-def-3': rPenaltyItem.DefinedByID == 3,
									'table-color-def-4': rPenaltyItem.DefinedByID == 4
								}"
							>
								{{ rPenaltyItem.DefinedByDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstPenaltyItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No actions configured...</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<!-- <div class="save-cancel-button-bar">
	<button class="btn btn-primary" style="margin-left: 0px;" (click)="onAddUpdate()" [disabled]="isBusy == true">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px;" (click)="onClose()">Cancel</button>
</div> -->
